// src/oura/components/newscan/StepHead.tsx
//
// The head of a New scan step: the one page title (32px), the step's sentence
// under it, and an optional slot on the right (the Questions | Words tabs).
// The title takes focus when the step changes (the page looks for
// `data-step-title`), the way the Drawer moves focus to its title.

import type { ReactNode } from "react";
import { cn } from "@oura/lib/cn";
import { TYPE } from "@oura/ui";

export interface StepHeadProps {
    title: ReactNode;
    /** 17px ink2 sentence under the title. */
    sentence?: ReactNode;
    /** Beside the title on wide screens, under it on a phone. */
    right?: ReactNode;
    /** id on the h1, for aria-labelledby on the step's panel. */
    id?: string;
    className?: string;
}

export function StepHead({ title, sentence, right, id, className }: StepHeadProps) {
    return (
        <header className={cn("mb-6 flex flex-wrap items-end justify-between gap-x-4 gap-y-3", className)}>
            <div className="min-w-0 flex-1 basis-80">
                <h1 id={id} data-step-title="" tabIndex={-1} className={cn(TYPE.h1, "m-0 break-words text-gray-900 outline-none")}>
                    {title}
                </h1>
                {sentence && <p className={cn(TYPE.ts, "m-0 mt-1 break-words")}>{sentence}</p>}
            </div>
            {right && <div className="flex min-w-0 max-w-full flex-wrap items-center gap-2">{right}</div>}
        </header>
    );
}
